export default __webpack_public_path__ + "static/media/premium_male.97fc26e6.png";